module.exports = __webpack_public_path__ + "static/media/publish-flyer-example.9ca86691.svg";